import { cn } from '@shared/lib/utils'
import { FormTextarea } from './FormTextarea'

export interface NoteFieldProps {
  value: string
  onChange: (value: string) => void
  label?: string
  description?: string
  placeholder?: string
  rows?: number
  required?: boolean
  maxLength?: number
  id?: string
  className?: string
}

const DEFAULTS = {
  label: 'Note (optional)',
  placeholder: 'Add any additional context...',
  rows: 3,
  required: false,
}

export function NoteField({
  value,
  onChange,
  label = DEFAULTS.label,
  description,
  placeholder = DEFAULTS.placeholder,
  rows = DEFAULTS.rows,
  required = DEFAULTS.required,
  maxLength,
  id,
  className,
}: NoteFieldProps) {
  return (
    <div className="space-y-1">
      <FormTextarea
        label={label}
        description={description}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        required={required}
        id={id}
        className={className}
      />
      {maxLength !== undefined && (
        <div className="flex justify-end">
          <span
            className={cn(
              'text-xs text-muted-foreground',
              value.length > maxLength && 'text-destructive'
            )}
          >
            {value.length}/{maxLength}
          </span>
        </div>
      )}
    </div>
  )
}
